var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Install",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Install .cls-1 {\n        fill: #33bc12;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1244.602 -344.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_579",
    "data-name": "Pfad 579",
    className: "cls-1",
    d: "M1264.6,384.125a20,20,0,1,1,20-20A20.022,20.022,0,0,1,1264.6,384.125Zm0-37.849a17.849,17.849,0,1,0,17.849,17.849A17.87,17.87,0,0,0,1264.6,346.276Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1692",
    "data-name": "Rechteck 1692",
    className: "cls-1",
    width: 7.742,
    height: 1.72,
    transform: "translate(1260.98 364.924)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1693",
    "data-name": "Rechteck 1693",
    className: "cls-1",
    width: 1.987,
    height: 1.43,
    transform: "translate(1263.857 355.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_581",
    "data-name": "Pfad 581",
    className: "cls-1",
    d: "M1271.166,354.376a3.608,3.608,0,1,0-7.216,0v1.144h7.216Zm-.86.284h-5.5v-.284a2.748,2.748,0,1,1,5.5,0Z",
    transform: "translate(-2.705 -0.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_582",
    "data-name": "Pfad 582",
    className: "cls-1",
    d: "M1269.794,365.32V362.2h1.2v-3.071H1263.6V362.2h1.187v3.116h-2.718v.86h10.449v-.86Zm-5.333-3.976v-1.351h5.669v1.351h-1.2v3.923h-3.286v-3.923Z",
    transform: "translate(-2.441 -2.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_580",
    "data-name": "Pfad 580",
    className: "cls-1",
    d: "M1253.962,376.582a.29.29,0,0,1,.127-.009q1.606.021,3.214.041a2.468,2.468,0,0,0,.583-.063.823.823,0,0,0,.653-.641,3.95,3.95,0,0,0,.09-1c0-.273-.008-.544-.016-.817a1.734,1.734,0,0,0-.029-.259.848.848,0,0,0-.778-.749,6.584,6.584,0,0,0-.9-.032c-.7,0-1.409,0-2.114,0-.268,0-.537-.021-.805-.027-.086,0-.093-.026-.063-.1a4.264,4.264,0,0,1,2.259-2.322,4.559,4.559,0,0,1,5.249,1.044,2.146,2.146,0,0,0,.248.244,1.146,1.146,0,0,0,.705.245q5.714.024,11.427.017c.5,0,1-.011,1.493.009a2.7,2.7,0,0,1,2.583,2.854,2.65,2.65,0,0,1-1.419,2.213,2.708,2.708,0,0,1-1.3.283q-2.734.01-5.468.012-3.475,0-6.951-.006a2.34,2.34,0,0,0-1.414.385,3.859,3.859,0,0,0-.359.3,4.094,4.094,0,0,1-3.2,1.062,4.546,4.546,0,0,1-3.058-1.492,4.178,4.178,0,0,1-.731-1.1C1253.977,376.647,1253.953,376.619,1253.962,376.582Zm22.339-.809a1.408,1.408,0,0,0-.016-1.915,1.357,1.357,0,0,0-1.9.026,1.3,1.3,0,0,0-.021,1.856A1.391,1.391,0,0,0,1276.3,375.773Z",
    transform: "translate(-1.301 -3.643)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.3eb568599de8bc25339c9c017d7d4416.svg";
export { ForwardRef as ReactComponent };